import {Stack, Typography} from "@mui/material";
import {MRT_TablePagination} from "material-react-table";

const DataGridHeader = ({table}) => {
    return (
        <Stack direction="row"
               alignItems="center"
               spacing={0}
               sx={(theme) => ({
                   justifyContent: 'space-between',
                   paddingLeft: '1rem',
                   height: '36px',
                   backgroundColor: theme.palette.background.paper,
               })}
        >
            <Stack direction="row">
                {table.getSelectedRowModel().rows.length === 0 && (
                    <></>
                )}
                {table.getSelectedRowModel().rows.length === 1 && (
                    <Typography variant="body2">1 row selected</Typography>
                )}
                {table.getSelectedRowModel().rows.length > 1 && (
                    <Typography variant="body2">{table.getSelectedRowModel().rows.length} rows selected</Typography>
                )}
            </Stack>

            <MRT_TablePagination table={table}/>
        </Stack>
    );
};

export default DataGridHeader;
